export default __webpack_public_path__ + "static/media/logo.d7615028.svg";